import React from 'react';
import SearchField from 'src/components/SearchField';
import SearchMaskField from 'src/components/SearchMaskField';
import SearchSelect from 'src/components/SearchSelect';
import { IPaginationParams } from 'src/models/interfaces/pagination';
import { VaccinationStatusTypeText } from 'src/types/IVaccination';
import { Container } from './styles';

interface IProps {
  params: IPaginationParams;
  mergeParams: (newParams: Partial<IPaginationParams>) => void;
}

const Filters = ({ params, mergeParams }: IProps) => {
  return (
    <Container>
      <SearchField
        placeholder='Digite ao menos 3 caracteres...'
        label='Pesquisar'
        width='250px'
        paginationParams={params}
        onChange={mergeParams}
      />
      <SearchSelect
        field='status'
        label='Status'
        onChange={mergeParams}
        options={Object.entries(VaccinationStatusTypeText).map(([key, value]) => {
          return { label: value, value: key };
        })}
      />
      <SearchMaskField
        field='startDate'
        label='Data Início'
        width='110px'
        paginationParams={params}
        type='date'
        onChange={mergeParams}
      />
      <SearchMaskField
        field='endDate'
        label='Data Fim'
        width='110px'
        paginationParams={params}
        type='date'
        onChange={mergeParams}
      />
    </Container>
  );
};

export default Filters;
